import type React from "react";

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Introduction</h2>
        <p className="mb-2">
          Welcome to the Washington ARML Team website ("WARML"). This Privacy
          Policy explains how we collect, use, and protect your information when
          you use our website.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Information We Collect</h2>
        <p className="mb-2">We collect the following information:</p>
        <ul className="list-disc pl-6 mb-2">
          <li>Your name and email address when you create an account</li>
          <li>Information about your practice and competition performance</li>
          <li>Basic usage data to help us improve the website</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">
          How We Use Your Information
        </h2>
        <p className="mb-2">We use your information to:</p>
        <ul className="list-disc pl-6 mb-2">
          <li>Manage your participation in the Washington ARML team</li>
          <li>Track your progress and performance</li>
          <li>Communicate with you about team activities and events</li>
          <li>Improve our website and services</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Data Security</h2>
        <p>
          We take reasonable measures to protect your personal information. We
          use secure authentication methods and store data securely.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">Contact Us</h2>
        <p>
          If you have any questions about this Privacy Policy or your data,
          please contact us at:
        </p>
        <p className="mt-2">Email: armlwacoach@gmail.com</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
